import TemplateView from '../../TemplateView'
import {getInstance as getSingletonTooltip} from '../../SimpleSingletonTooltip'
import messageResource from '../../messageResource'

/**
 * Renders list of password requirements
 */
export default class PasswordHint extends TemplateView {
    constructor({policyManager, validatorId = undefined}) {
        super();
        this.policyManager = policyManager
        if (validatorId === undefined) {
            this.getTipsArray = policyManager.getPasswordTips.bind(policyManager);
        } else {
            this.getTipsArray = policyManager.getPasswordTipsFor.bind(policyManager, validatorId);
        }
    }

    useUnderscoreTemplate() { return false; }

    templateHtml() {
        //grishin: I do not think that usage of underscore template's <% _.forEach ... %> is better than string concat.
        return "<ul class='passwordHint'>" + this.getTipsArray().map(tip => "<li>" + tip + "</li>").join("") + "</ul>";
    }

    afterRender() {
        if (this.policyManager.hasSpecialCharacter()) {
            const $specialCharacter = this.find('.specialCharacter')
            getSingletonTooltip().subscribeToMouseEvents($specialCharacter, () => {
                getSingletonTooltip().setState({
                    text: messageResource.getMessage('password_validation.characters.special.hint.tooltip'),
                    extraClass: 'specialCharacterTooltip',
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordHint.js